import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      'An unexpected error occurred';
    console.error('API Error:', message);
    return Promise.reject({ message, status: error.response?.status });
  }
);

// Customers
export const getCustomers = (params) => api.get('/customers', { params });
export const getCustomer = (id) => api.get(`/customers/${id}`);
export const createCustomer = (data) => api.post('/customers', data);
export const updateCustomer = (id, data) => api.put(`/customers/${id}`, data);

// Transactions
export const getTransactions = (params) => api.get('/transactions', { params });
export const createTransaction = (data) => api.post('/transactions', data);

// Models
export const runModel = (modelName, params) =>
  api.post(`/models/${modelName}/run`, params);
export const getModelResults = (modelName, params) =>
  api.get(`/models/${modelName}/results`, { params });

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');
export const getDashboardCharts = () => api.get('/dashboard/charts');

// Test & Learn
export const getExperiments = () => api.get('/experiments');
export const createExperiment = (data) => api.post('/experiments', data);
export const getExperiment = (id) => api.get(`/experiments/${id}`);

// Settings
export const getSettings = () => api.get('/settings');
export const updateSettings = (data) => api.put('/settings', data);

// Data Manager
export const uploadData = (formData) =>
  api.post('/data/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
export const getDataSources = () => api.get('/data/sources');

export default api;
